import { TEventShelf } from "../../utils/@types/store"

const eventShelf = (): TEventShelf => {
  return null
}

export default eventShelf
